import { atom } from 'jotai/index';
import { getThermometerEntries } from './thermometerAPI';
import { ThermometerDataPoint } from '../modules/interfaces';
export const selectedThermometerStateAtom = atom(0);

export const hydratedThermometerDataPointsAtom = atom<ThermometerDataPoint[]>();
/// If hydratedThermometerDataPointsAtom is set, that value will be used. Otherwise, data will be downloaded from the API.
export const thermometerDataPointsAtom = atom((get) => {
    const hydratedValue = get(hydratedThermometerDataPointsAtom);
    return hydratedValue ?? getThermometerEntries();
});
